import { Pipe, PipeTransform } from '@angular/core';
import { PlaceValue } from 'src/app/core/constants/types.constants';

@Pipe({
    name: 'placeValue',
    standalone: true,
    pure: true
})
export class PlaceValuePipe implements PipeTransform {
    transform(number: number, displayIn: PlaceValue): number {
        if (number === 0) return 0;

        // Get the absolute value of the number
        let abs: number = Math.abs(number);

        // 10^1
        const tenToThePowerOne = Math.pow(10, 1);

        /**
         * Denominators and their powers information
         * Divide value with 10^9 to get in terms of billions
         * Divide value with 10^6 to get in terms of millions
         * Divide value with 10*3 to get in terms of thousands
         */
        const powers: { [key in PlaceValue]: string } = {
            billion: 'abs / Math.pow(10, 9)',
            million: 'abs / Math.pow(10, 6)',
            thousand: 'abs / Math.pow(10, 3)',
            hundred: 'abs'
        };

        /**
         * Original Value: 826014779320.205
         * Value after Step 1: 826014.779320205
         * Value after Step 2: 826014.8
         */

        /* STEP 1*/
        let placeHolderValue: number = eval(powers[displayIn]);

        /* STEP 2 */
        placeHolderValue = Math.round(placeHolderValue * tenToThePowerOne) / tenToThePowerOne;

        return placeHolderValue;
    }
}
